import { getKeys } from './getKeys'

export const riskAssessmentFormTranslations = {
  ATTACHED_TO: 'Attached to {{carePlanNominative}}',
  RISK_OUTCOME_SCORE: 'Risk Outcome Score',
  ACTIONS_TO_MITIGATE: 'Actions to mitigate this risk',
  CONFIRM_TEXT: 'Ok',
  CANCEL_TEXT: 'Cancel',
  PLEASE_NOTE: 'Please Note',
  UPDATING_RISK_ASSESSMENT:
    'Updating this risk assessment will require you to review the following {{carePlanNominative}}:',
  ACTIONS_NOTE:
    'Any text you include in this box will be copied into the ‘Actions’ box inside the {{carePlanNominative}} when you save this Risk Assessment. To edit this text, you must return to this Risk Assessment.',
  PASSPORT_NOTE:
    "Please Note: This risk assessment isn't connected to a {{carePlanNominative}}, so won't be attached in the hospital passport",
  REVIEW_CARE_PLAN_NOTE:
    "Please Note: You haven't reviewed any {{carePlanNominative}} yet. You can attach this assessment to a {{carePlanNominative}} during a review or come back here afterwards.",
  CARE_PLAN: 'Care Plan',
  CARE_PLANS: 'Care Plans',
  NOT_LINKED_TO_ANY_CARE_PLAN: 'Not linked to any care plan'
}

export const riskAssessmentFormConstants = getKeys(
  riskAssessmentFormTranslations
)
